import { render, staticRenderFns } from "./UserPackage.vue?vue&type=template&id=358880f4"
import script from "./UserPackage.vue?vue&type=script&lang=js"
export * from "./UserPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports